<template>
  <div v-if="tab == 'tab-1' || tab == 'tab-2'" class="promotion-list">
    <!-- promoções de freespins: ativas -->
    <CasinoPromos
      v-if="isActiveCampaigns"
      :activeCampaigns="activeCampaigns"
      :historic="tab === 'tab-2'"
    />

    <!-- DEPRECATED - promoções de freespins: histórico -->
    <HistoricCampaigns
      v-if="isHistoricCampaigns"
      :historicCampaigns="activeCampaigns"
    />

    <!-- promoções de esportes: ativas e histórico -->
    <SportsPromos
      v-else
      :promotions="promotions"
      :history="history"
    />
   
    <PromotionExtract
      :dialog="promotionExtractDialog"
      :promotion="currentPromotionExtract"
      @closeDialog="promotionExtractDialog = false"
    />

    <PromotionDetail
      :dialog="promotionDetailDialog"
      :promotion="currentPromotionDetail"
      @closeDialog="promotionDetailDialog = false"
    />
  </div>
</template>
<script>
import CasinoPromos from "./CasinoPromos.vue";
import HistoricCampaigns from "./HistoricCampaigns.vue";
import PromotionExtract from "./PromotionExtract";
import PromotionDetail from "./PromotionDetail";
import SportsPromos from './SportsPromos.vue';

export default {
  props: [
    "tab",
    "promotions",
    "fetchPromotions",
    "history",
    "activeCampaigns",
    "historicCampaigns",
    "isActiveCampaigns",
    "isHistoricCampaigns",
  ],

  components: {
    CasinoPromos,
    HistoricCampaigns,
    PromotionExtract,
    PromotionDetail,
    SportsPromos,
  },

  data: () => ({
    promotionDetailDialog: false,
    promotionExtractDialog: false,
    currentPromotionDetail: {},
    currentPromotionExtract: {},
  }),
};
</script>

<style>
.promotion-list .v-list-item__icon {
  display: flex;
  align-self: center;
}
</style>
